// Build-time config read from Vite env. The Google OAuth client ID is public
// (it's the audience for an ID token; not a secret). Hosted domain matches the
// api's GOOGLE_OAUTH_HOSTED_DOMAIN — server-side is authoritative, but the
// client checks it too for a friendly wrong-domain toast (ADMIN_UI §5.1.5).

export const GOOGLE_CLIENT_ID = (import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '') as string;
export const HOSTED_DOMAIN = (import.meta.env.VITE_GOOGLE_HOSTED_DOMAIN ??
  'tapslots.com') as string;
